import { render } from "./twelve-best.vue?vue&type=template&id=052fb4a8"
import script from "./twelve-best.vue?vue&type=script&lang=js"
export * from "./twelve-best.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__